import { render } from "./DaumCloseInject.vue?vue&type=template&id=7dc03596"
const script = {}

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/checkout/injectComponents/DaumCloseInject.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7dc03596"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7dc03596', __exports__)) {
    api.reload('7dc03596', __exports__)
  }
  
  module.hot.accept("./DaumCloseInject.vue?vue&type=template&id=7dc03596", () => {
    api.rerender('7dc03596', render)
  })

}


export default __exports__